module.exports = __webpack_public_path__ + "img/word.1615855b.svg";